<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
<!--                            buat dialog dengan input tanggal-->
                            <Dialog header="Upload SK Penetapan" :visible="displayBasic" :modal="true" :closable="false" :style="{ width: '50vw' }">
                                <div class="p-fluid px-3 mb-3">
                                        <JetLabel
                                            class="w-full"
                                            for="role"
                                            value="Pilih Role"
                                        />
                                        <Dropdown class="w-full md:w-14rem" v-model="inputRole" :options="selectRole" optionLabel="name" placeholder="Pilih Jenis Role" required="required" >
                                            <template #option="slotProps">
                                                <div class="country-item">
                                                    <div>{{slotProps.option.name}}</div>
                                                </div>
                                            </template>
                                        </Dropdown>
                                </div>
                                <div class="p-fluid px-3 mb-3">
                                        <JetLabel
                                            class="w-full"
                                            for="unit"
                                            value="Pilih Unit"
                                        />
                                        <Dropdown class="w-full md:w-14rem" v-model="inputUnit"  :options="selectUnit" optionLabel="nama_unit" placeholder="Pilih Unit" required="required" >
                                            <template #option="slotProps">
                                                <div class="country-item">
                                                    <div>{{slotProps.option.nama_unit}}</div>
                                                </div>
                                            </template>

                                        </Dropdown>

                                </div>
                                <div class="p-fluid px-3 mb-3">
                                    <div class="p-field">
                                        <JetLabel
                                            class="w-full"
                                            for="file_sk"
                                            value="SK DRM (PDF) Max 2MB"
                                        />
                                        <Input
                                            type="file"
                                            class="mt-1 block w-full"
                                            accept="application/pdf"
                                            v-on:change="onChangeFileUpload($event)"
                                        />
                                    </div>
                                </div>
                                <template #footer>
                                    <div class="p-d-flex p-jc-end">
                                        <Button label="Batal" @click="displayBasic=false" />
                                        <Button label="Tetapkan" @click="buatDaftar" />
                                    </div>
                                </template>
                            </Dialog>
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Toolbar>
                                    <template #start>
                                        <ButtonAdd
                                            :disabled="
                                                selected.length == 0 ||
                                                !allow_to_proceed
                                            "
                                            label="Buat Penetapan"
                                            @click="buat($event)"
                                            class="mr-1"
                                        />
                                    </template>
                                    <template #end>
                                    </template>
                                </Toolbar>
                            </div>
                            <div class="w-full mb-20">
                                <EzDataTable
                                    ref="ezdt"
                                    :config="ezdtConfig"
                                    @getSelectedData="getSelected"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import EzDataTable from "@/Components/EzDataTable";
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import ButtonLinkAdd from "@/Components/ButtonLinkAdd";
import ButtonLinkEdit from "@/Components/ButtonLinkEdit";
import ButtonLinkShow from "@/Components/ButtonLinkShow";
import ButtonDelete from "@/Components/ButtonDelete";
import ButtonEdit from "@/Components/ButtonEdit.vue";
import ButtonAdd from "@/Components/ButtonAdd.vue";
import Dialog from 'primevue/dialog';
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input";
import { Pesan } from "@/constants";
import InputError from "@/Components/InputError.vue";
import Dropdown from 'primevue/dropdown';

export default defineComponent({
    components: {
        InputError,
        AppLayout,
        BreadCrumb,
        EzDataTable,
        Toolbar,
        Button,
        ButtonLinkAdd,
        ButtonLinkEdit,
        ButtonLinkShow,
        ButtonDelete,
        ButtonEdit,
        ButtonAdd,
        Dialog,
        JetLabel,
        Input,
        Dropdown,
    },
    props: {
        selectUnit : Array,
        selectRole : Array,
    },
    data() {
        return {
            file_sk: '',
            ezdtConfig: {
                dtHeader: "Daftar Pegawai",
                globalFilter: ["nip, nama_lengkap, email"],
                sortBy: "created_at",
                defineCols: [
                    {
                        field: "nip",
                        header: "nip",
                        style: "min-width: 20rem",
                        isFrozen: true,
                        col_type: "text",
                    },
                    {
                        field: "nama_lengkap",
                        header: "nama",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "email",
                        header: "email",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                ],
                dtSourceApiRoute: {
                    list: "penetapan.dataPegawai",
                    // show: "penyedia.show",
                    // edit: "penyedia.edit",
                    // destroy: "penyedia.destroy",
                },
            },
            selected: [],
            selected_id: 0,
            allow_to_proceed: true,
            displayBasic: false,
            inputUnit: '',
            inputRole: '',
            lokasi: null,
        };
    },
    methods: {
        loadEzData: function () {
            // this.allow_to_proceed = false;
            this.$refs.ezdt.loadData();
        },
        getSelected: function (data) {
            this.selected = data;
            this.selected_id = 0;
            if (data.length == 1) {
                this.selected_id = data[0]["user_id"];
                console.log(this.selected_id);
            }
        },
        tambah: function (event) {
            //
        },
        edit: function (event) {
            //
        },

        onChangeFileUpload(event){
            this.file_sk = event.target.files[0];
            console.log(this.file_sk);
        },
        buat: function (event) {

            let ids = [];
            this.selected.forEach(function (item, index) {
                ids.push(item.id);
            });
            // tampilkan modal
            this.displayBasic = true;

        },
        buatDaftar: function (event) {
            let ids = [];
            this.selected.forEach(function (item, index) {
                ids.push(item.id);
            });
            let formData = new FormData();
            formData.append('ids', ids);
            formData.append('role', this.inputRole.id);
            formData.append('unit', this.inputUnit.id);
            formData.append('file_sk', this.file_sk);

            // update data
            // console.log(this.tanggal);
           axios
               .post(route("penetapan.create"), formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then((response) => {
                    if(response.data.stts == 'ok'){
                        this.$toast.add({
                            severity: "success",
                            summary: "Success",
                            detail: response.data.msg,
                            life: 3000,
                        });
                        // redirect inertia /penyedia/daftarRekananMampu
                        this.$inertia.visit('/penetapan');
                    }else{
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: response.data.msg,
                            life: 3000,
                        });

                    }

                    // this.loadEzData();
                    //redirect kehalaman response.url
                    // window.location.href = response.data.url;
                    // console.log(response.data);
                    this.displayBasic = false;
                })
                .catch((error) => {
                    // console.log(error);
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: response.data.msg,
                        life: 3000,
                    });

                });

        },
    },
});
</script>
